<template>
  <div
    class="mt3" >
    <div
      v-if="!printerFriendly"
      style="padding-left:10px;">
      <div class="stratline">
        <div class="label">View by</div>
        <div class="dib">
          <LPStratFilter
            :id="indicatorId + '_sc1'"
            :items="stratCats1"
            v-model="filterState.stratCatId1"
            :show-debug-ids="showDebugIds"
            label="View by"
            class="stratcat"
          />
        </div>
        <div
          v-if="showStrat1"
          class="dib">
          <LPStratFilter
            :id="indicatorId + '_s1'"
            :items="strats1"
            v-model="filterState.stratId1"
            :show-debug-ids="showDebugIds"
            label="View by"
            class="strat"
          />
        </div>
        <div
          v-if="xAxisColumn === 's1' && showDebugIds"
          class="dib"
        >{{ xAxisPointer }}</div>
        <div
          v-if="legendColumn === 's1' && showDebugIds"
          class="dib"
        >{{ legendPointer }}</div>
      </div>
      <div
        v-if="hasLevel2"
        class="stratline">
        <div class="label">View by</div>
        <div class="dib">
          <LPStratFilter
            :id="indicatorId + '_sc2'"
            :items="stratCats2"
            v-model="filterState.stratCatId2"
            :show-debug-ids="showDebugIds"
            label="View by"
            class="stratcat"
          />
        </div>
        <div class="dib">
          <LPStratFilter
            :id="indicatorId + '_s2'"
            :items="strats2"
            v-model="filterState.stratId2"
            :show-debug-ids="showDebugIds"
            label="View by"
            class="strat"
          />
        </div>
        <div
          v-if="xAxisColumn === 's2' && showDebugIds"
          class="dib"
        >{{ xAxisPointer }}</div>
        <div
          v-if="legendColumn === 's2' && showDebugIds"
          class="dib"
        >{{ legendPointer }}</div>
      </div>
      <div class="stratline">
        <div class="label">Response</div>
        <div class="dib">
          <LPStratFilter
            :id="indicatorId + '_rs'"
            :items="responses"
            v-model="filterState.responseId"
            :show-debug-ids="showDebugIds"
            label="Response"
            class="response"
          />
        </div>
        <div
          v-if="xAxisColumn === 'rs' && showDebugIds"
          class="dib"
        >{{ xAxisPointer }}</div>
        <div
          v-if="legendColumn === 'rs' && showDebugIds"
          class="dib"
        >{{ legendPointer }}</div>
      </div>
      <div class="stratline">
        <div class="label">Year</div>
        <div
          v-if="years.length === 1"
          class="dib">{{ year }}</div>
        <div
          v-else
        >
          <fieldset class="hideFieldset">
            <legend class="accessibleHide">Year</legend>
            <div class="year">
              <LPStratFilter
                :items="years"
                :id="'islYear_' + indicatorId"
                v-model="filterState.yearId"
                :show-debug-ids="showDebugIds"
                label="Year"
                class="year"
              />
            </div>

            <div
              v-if="xAxisColumn === 'yr' && showDebugIds"
              class="dib"
            >{{ xAxisPointer }}</div>
          </fieldset>
        </div>
      </div>
      <div
        v-if="showDataValueTypes"
        class="stratline">
        <div class="label">Data Type</div>
        <div class="dib">
          <LPStratFilter
            :id="indicatorId + '_dvt'"
            :items="dataValueTypes"
            v-model="filterState.dataValueTypeId"
            :show-debug-ids="showDebugIds"
            label="Data Type"
          />
        </div>
      </div>
    </div>
    <VisualizationTitle :filter-state="filterState"/>
  </div>
</template>

<style scoped>

.mt3  {  margin-top: 1rem; }
  .stratline {
    display: table;
    margin: 5px 0;
  }
.label {
    display: table-cell;
    vertical-align: top;
    font-weight: bold;
    width: 85px;
    padding-right:5px;
  }
  .hideFieldset {
    border: none;
    display: inline;
    padding: 0;
    margin: 0;
  }
  .dib {
    display: inline-block;
  }
  .b {
    font-weight: bold;
  }
  .stratcat {
    width: 150px;
  }
  .strat {
    width: 150px;
    margin: 0 5px;
  }
  .response {
    max-width: 306px;
    margin-right: 5px;
  }
  .year {
    padding: 0;
  }
</style>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';
import LPStratFilter from '../common/StratFilter';
import TempDisplayRawQuestionData from './TempDisplayRawQuestionData';
import LPChartView from './ChartView';
import LPTableView from './TableView';
import VisualizationTitle from './VisualizationTitle';

const overallStratCatId = 'CAT1';

function addAllOption(list, boolAdd) {
  if (boolAdd) {
    list.splice(0, 0, { id: '', name: 'All' });
  }
  return list;
}

function hasAllOption(list) {
  return _(list).filter({ id: '' }).compact().value().length === 1;
}

// const maxAllCount = 2;

export default {
  name: 'LPStratFilters',
  components: {
    LPStratFilter,
    TempDisplayRawQuestionData,
    LPChartView,
    LPTableView,
    VisualizationTitle,
  },
  data() {
    return {
      filterState: {
        multistrat: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'multistrat'),
        yearId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'yearId'),
        stratCatId1: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'stratCatId1'),
        stratId1: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'stratId1'),
        stratCatId2: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'stratCatId2'),
        stratId2: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'stratId2'),
        responseId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'responseId'),
        dataValueTypeId: this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'dataValueTypeId'),
        legendColumn: '',
        legendType: '',
      },
      useCurrentIdIfValid: false,
    };
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      dataTypes: state => state.dataTypes,
      questionData: state => state.LP.questionData,
      indicatorId: state => state.LP.indicatorId,
      showDebugIds: state => state.flags.showDebugIds,
      isMapView: state => state.LP.flags.isMapView,
      visualizationChanged: state => state.LP.flags.visualizationChanged,
      view: state => state.LP.view,
      initialPageLoad: state => state.flags.initialPageLoad,
      indicatorChanged: state => state.LP.flags.indicatorChanged,
    }),
    maxAllCount() {
      return this.view === 'Map' ? 1 : 2;
    },
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    stratCats1() {
      return _(this.questionData)
        .map('sc1').uniq()
        .map(id => this.lku.StratificationCategory[id])
        .orderBy('sort', 'asc')
        .value();
    },
    showStrat1() {
      return this.filterState.stratCatId1 !== overallStratCatId;
    },
    hasLevel2() {
      return !_.isUndefined(_(this.questionData)
        .find(o => o.sc1 === this.filterState.stratCatId1 && o.sc2));
    },
    strats1() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      const rows = _(this.questionData).filter(filter)
        .map('s1').uniq()
        .map(id => this.lku.Stratification[id])
        .orderBy('sort', 'asc')
        .value();
      const addAll = false; // 1 = all locations
      return addAllOption(rows, addAll);
    },
    stratCats2() {
      if (!this.hasLevel2) return [];
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      const rows = _(this.questionData).filter(filter)
        .map('sc2').uniq()
        .compact() // remove undefined from array if above key is not found
        .map(id => this.lku.StratificationCategory[id])
        .orderBy('sort', 'asc')
        .value();
      const hasLevel1 = _(this.questionData).filter(filter).filter(o => !o.sc2).value().length > 0;
      if (hasLevel1) {
        return helper.addSelectOne(rows);
      }
      return rows;
    },
    strats2() {
      if (this.filterState.stratCatId2 === '') return [];
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      const rows = _(this.questionData).filter(filter)
        .map('s2').uniq()
        .compact() // remove undefined from array if above key is not found
        .map(id => this.lku.Stratification[id])
        .orderBy('sort', 'asc')
        .value();
      const addAll = false; // 1 = all locations
      return addAllOption(rows, addAll);
    },
    responses() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      const rows = _(this.questionData).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .map('rs')
        .uniq()
        .map(id => this.lku.Response[id])
        .orderBy('sort', 'asc')
        .value();
      const addAll = false;
      return addAllOption(rows, addAll);
    },
    years() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      return _(this.questionData).filter(filter)
        .map('yr').uniq()
        .map(id => this.lku.Year[id])
        .orderBy('sort', 'desc')
        .value();
    },
    year() {
      const row = this.lku.Year[this.filterState.yearId];
      return row ? row.name : '';
    },
    yearId() {
      return this.filterState.yearId;
    },
    dataValueTypes() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      if (this.filterState.yearId) filter.yr = this.filterState.yearId;
      return _(this.questionData).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .map('dvt')
        .uniq()
        .map(id => this.lku.DataValueType[id])
        .orderBy('sort', 'asc')
        .value();
    },
    multistrat() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      if (this.filterState.yearId) filter.yr = this.filterState.yearId;
      filter.dvt = this.filterState.dataValueTypeId;

      return _(this.questionData).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .map('multistrat')
        .uniq()
        .head();
    },
    showDataValueTypes() {
      return this.dataValueTypes.length > 1;
    },
    filteredData() {
      const filter = {};
      filter.sc1 = this.filterState.stratCatId1;
      if (this.filterState.stratId1) filter.s1 = this.filterState.stratId1;
      if (this.filterState.stratCatId2) filter.sc2 = this.filterState.stratCatId2;
      if (this.filterState.stratId2) filter.s2 = this.filterState.stratId2;
      if (this.filterState.responseId) filter.rs = this.filterState.responseId;
      if (this.filterState.yearId) filter.yr = this.filterState.yearId;
      filter.dvt = this.filterState.dataValueTypeId;
      return _(this.questionData).filter(filter)
        // remove level2 rows if hasLevel2 and stratCatId2 is blank
        .filter(o => (this.hasLevel2 && this.filterState.stratCatId2 === '' ? !o.s2 : true))
        .value();
    },
    xAxisColumn() {
      if (this.filterState.stratId1 === ''
        && this.filterState.stratCatId2 !== ''
        && this.filterState.stratId2 === '') {
        return 's1';
      }
      return 'rs';
    },
    xAxisType() {
      if (this.xAxisColumn === 'yr') return 'Year';
      if (this.xAxisColumn === 'rs') return 'Response';
      return 'Stratification';
    },
    legendColumn() {
      if (this.filterState.stratId1 === '') return 's1';
      if (this.filterState.stratCatId2 !== ''
        && this.filterState.stratId2 === '') return 's2';
      return 'rs';
    },
    legendType() {
      if (this.legendColumn === 'rs') return 'Response';
      return 'Stratification';
    },
    legendTitle() {
      if (this.filteredData.length === 0) return '';
      if (this.legendColumn === 'rs') return 'Response';
      if (this.legendColumn === 's1'
        && this.filterState.stratCatId1 === overallStratCatId) return '';
      const legendTitleColumn = this.legendColumn === 's1' ? 'sc1' : 'sc2';
      return this.lku.StratificationCategory[this.filteredData[0][legendTitleColumn]].name;
    },
    displayTrendChart() {
      return this.years.length > 2;
    },
    chartConfigObject() {
      return {
        xAxisColumn: this.xAxisColumn,
        xAxisType: this.xAxisType,
        legendColumn: this.legendColumn,
        legendType: this.legendType,
        legendTitleStr: this.legendTitle,
        displayTrendChart: this.displayTrendChart,
        chartDivId: 'chartDiv',
        colorsArrStr: ['#FFFF99', '#FDBF6F', '#FF7F00', '#CAB2D6', '#f781bf', '#a65628', '#ff7f00', '#984ea3', '#4daf4a', '#e41a1c', '#377eb8'].reverse(),
        yAxisTitle: this.dataTypesProperties('chartAxisLabel'),
        decimalPlaces: this.dataTypesProperties('decimalPlaces'),
        confidenceIntervalLabel: this.dataTypesProperties('ciRowLabel'),
        sampleSizeLabel: this.dataTypesProperties('sampleSizeLabel'),
        dataValuePrefix: this.dataTypesProperties('dataValuePrefix'),
        dataValueSuffix: this.dataTypesProperties('dataValueSuffix'),
        chartTitle508: 'chart 508 title goes here',
        chartDesc508: 'chart 508 desc goes here',
      };
    },
    tableConfigObject() {
      return {
        groupColumn: 'loc',
        groupType: 'Location',
        headingColumn: this.legendColumn,
        headingType: this.legendType,
        ssColumn: 'wn',
        dataRowLabel: this.dataTypesProperties('dataRowLabel'),
        ciRowLabel: this.dataTypesProperties('confidenceIntervalLabel'),
        ssRowLabel: this.dataTypesProperties('sampleSizeLabel'),
        decimalPlaces: this.dataTypesProperties('decimalPlaces'),
        tableSummary508: 'table 508 summary goes here',
      };
    },
    xAxisPointer() {
      return '<===chart x-axis/table group rows';
    },
    legendPointer() {
      return '<===chart legend/table columns';
    },
    stratFilterObj() {
      return {
        questionId: this.indicatorId,
        multistrat: this.multistrat,
        yearId: this.filterState.yearId,
        stratCatId1: this.filterState.stratCatId1,
        stratId1: this.filterState.stratId1,
        stratCatId2: this.filterState.stratCatId2,
        stratId2: this.filterState.stratId2,
        responseId: this.filterState.responseId,
        dataValueTypeId: this.filterState.dataValueTypeId,
        legendColumn: this.legendColumn,
        legendType: this.legendType,
      };
    },
    stratFilterChangeWatchable() {
      const fs = this.filterState;
      return `${fs.stratCatId1},${fs.stratId1},${fs.stratCatId2},${fs.stratId2},${fs.responseId},${fs.yearId}`;
    },
  },
  watch: {
    stratFilterObj() {
      // This is the last strat filter dropdown watch in the chain. Set the useCurrentIdIfValid
      // flag to true so previously selected filter values are preserved when a filter dropdown
      // is changed and subsequent filter dropdown values are still valid.
      this.useCurrentIdIfValid = true;
      // this.$store.commit('setInitialPageLoad', false);
      this.$store.commit('LP/setVisualizationChanged', false);
      if (this.indicatorChanged) {
        this.$store.commit('LP/setIndicatorChanged', false);
        this.getLPDataDebounce();
      } else {
        // use debounce function to rate limit api calls when filter dropdowns are changed
        // via the keyboard up/down keys
        this.getLPDataDebounce();
      }
    },
    indicatorChanged() {
      if (this.indicatorChanged && !this.initialPageLoad) {
        // The Go button was clicked or the indicator dropdown was changed
        // which causes indicatorChanged flag to be set to true.
        // Force the strat filters to reset to their default
        // values instead of retaining their current
        // values (if valid) if this is not the initial page load.
        this.useCurrentIdIfValid = false;
      }
    },
    years() {
      this.filterState.yearId = helper.defaultOrFirstIdLP(
        this.years,
        this.filterState.yearId,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    stratCats1() {
      this.filterState.stratCatId1 = helper.defaultOrFirstIdLP(
        this.stratCats1,
        this.filterState.stratCatId1,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    strats1() {
      if (hasAllOption(this.strats1)) this.useCurrentIdIfValid = false;
      this.filterState.stratId1 = helper.defaultOrFirstIdLP(
        this.strats1,
        this.filterState.stratId1,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    stratCats2() {
      this.filterState.stratCatId2 = helper.defaultOrFirstIdLP(
        this.stratCats2,
        this.filterState.stratCatId2,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    strats2() {
      if (hasAllOption(this.strats2)) this.useCurrentIdIfValid = false;
      this.filterState.stratId2 = helper.defaultOrFirstIdLP(
        this.strats2,
        this.filterState.stratId2,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    responses() {
      if (hasAllOption(this.responses)) this.useCurrentIdIfValid = false;
      this.filterState.responseId = helper.defaultOrFirstIdLP(
        this.responses,
        this.filterState.responseId,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );
    },
    dataValueTypes() {
      this.filterState.dataValueTypeId = helper.defaultOrFirstIdLP(
        this.dataValueTypes,
        this.filterState.dataValueTypeId,
        this.useCurrentIdIfValid,
        this.initialPageLoad,
        this.visualizationChanged,
      );

      this.$store.commit('setInitialPageLoad', false);
    },
    // watches for individual strat filter properties fire in
    // an indeterminite order so we can't easily determine
    // the actual interaction type, the dummy SF interaction type
    // is used instead
    stratFilterChangeWatchable() {
      // console.log('stratFilterChangeWatchable', this.stratFilterChangeWatchable);
      this.$store.commit('LP/setInteractionTypeIfEmpty', 'SF');
    },
  },
  methods: {
    getLPDataDebounce:
        _.debounce(function fnToDebounce() {
          const payload = { filterObj: this.stratFilterObj, router: this.$router };
          this.$store.dispatch('LP/getLPData', payload);
        }, process.env.DebounceDelay),
    dataTypesProperties(prop) {
      const row = this.dataTypes[this.filterState.dataValueTypeId];
      return row ? row[prop] : '';
    },
    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/LP/StratFilters.vue